export const ERP_NAVIGATION = 'erp_navigation'
export const ERP_AFTERSALE_AUTO_PUSH = 'erp_afterSale_autoPush'
export const ERP_NAV_ORDER = 'erp_nav_order'
export const ERP_NAV_ORDER2 = 'erp_nav_order2'
export const ERP_NAV_FUND = 'erp_nav_fund'
export const ERP_NAV_MYCHANNEL = 'erp_nav_mychannel'
export const ERP_NAV_CHANNEL_GOODS = 'erp_nav_channel_goods'
export const ERP_NAV_MYSUPPLIER = 'erp_nav_mysupplier'
export const ERP_INDEX_LINK_ORDER = 'erp_index_link_order'
export const ERP_NAV_PROCE_QUANTITY = 'erp_nav_price_quantity'
export const ERP_MENU_IM_DISTRIBUTE = 'erp_menu_im_distributor'

// 供销订单（新增）
export const ERP_MENU_SUPPLIER_TOOL_DISTRIBUTION_ORDER = 'erp_menu_suppiler_tools_distribution_order'
// 分销售后（新增）
export const ERP_MENU_SUPPLIER_TOOL_DISTRIBUTION_AFTER_SALES = 'erp_menu_suppiler_tools_distribution_after_sales'
// 分销商数据（新增）
export const ERP_MENU_SUPPILER_TOOL_DISTRIBUTION_DATA = 'erp_menu_suppiler_tools_distributor_data'

// 分销售后（新增）
export const ERP_MENU_DISTRIBUTOR_TOOL_DISTRIBUTION_AFTER_SALES = 'erp_menu_distributor_tools_distributor_after_sales'
// 供应商数据（新增）
export const ERP_MENU_DISTRIBUTOR_TOOL_DISTRIBUTION_SUPPLIER_DATA = 'erp_menu_distributor_tools_suppiler_data'

// erp的授权页面跳转到我们的店铺列表
export const ERP_AUTH_PAGE_TO_SHOP_LIST = 'erp_auth_page_to_shop_list'

// 合伙人招募
export const GYL_PARTNERSHIP_INVITE = 'gyl_partnership_invite'
/**
 * 合伙人-复制链接给合伙人审核
 */
export const GYL_PARTNERSHIP_WAIT_CONFIRM = 'GYL_PARTNERSHIP_WAIT_CONFIRM'

export default {
    ERP_NAVIGATION,
    ERP_NAV_ORDER,
    ERP_NAV_ORDER2,
    ERP_NAV_FUND,
    ERP_NAV_MYCHANNEL,
    ERP_NAV_MYSUPPLIER,
    ERP_INDEX_LINK_ORDER,
    ERP_NAV_PROCE_QUANTITY,
    ERP_MENU_IM_DISTRIBUTE,
    ERP_AUTH_PAGE_TO_SHOP_LIST,
    ERP_MENU_SUPPLIER_TOOL_DISTRIBUTION_ORDER,
    GYL_PARTNERSHIP_INVITE,
    GYL_PARTNERSHIP_WAIT_CONFIRM,
}
